import FetchService from '../../../core/services/FetchService';
import { action, extendObservable } from 'mobx';

class SystemTranslationEmailTemplateStatisticService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      summary: 0,
      fetching: false,
    });
  }

  load = action(() => {
    this.fetch
      .fetch({
        url: '/email-templates/total',
      })
      .then(() => {
        if (this.fetch.data) {
          this.summary = this.fetch.data.total;
        }
        if (this.fetch.error) {
          this.summary = 0;
        }
      });
  });
}

export default SystemTranslationEmailTemplateStatisticService;
